import type { Sheet as EmojiMartSheet } from '@emoji-mart/data';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

import { Spinner } from '@trello/nachos/spinner';

import { EmojiProvider } from './EmojiProvider';

export interface EmojiProviderProps {
  children: (
    sheet: EmojiMartSheet,
    backgroundImageFn: typeof EmojiProvider.getSpritesheetsUrl | undefined,
  ) => ReactNode;
  isSmallSpinner?: boolean;
}

export const EmojiProviderComponent = ({
  children,
  isSmallSpinner = false,
}: EmojiProviderProps) => {
  const [sheet, setSheet] = useState<EmojiMartSheet | null>(
    EmojiProvider.getSheetDataSync(),
  );

  useEffect(() => {
    if (!sheet) {
      EmojiProvider.getSheetData().then((newSheet) => {
        if (newSheet) {
          setSheet(newSheet);
        }
      });
    }
  }, [sheet]);

  const getBackgroundImageFn = () => {
    const spriteSheets = EmojiProvider.getSpritesheetsSync();
    if (spriteSheets) {
      return function () {
        return EmojiProvider.getSpritesheetsUrl.apply(EmojiProvider, [
          'twitter',
          64, // currently, the picker uses a large emoji as the preview
        ]);
      };
    }

    return undefined;
  };

  if (sheet) {
    return children(sheet, getBackgroundImageFn());
  }

  return (
    <div>
      <Spinner small={isSmallSpinner} centered={!isSmallSpinner} />
    </div>
  );
};
